import UserOrder from './UserOrder';
import withProps from 'recompose/withProps';
import withState from 'recompose/withState';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import { fetchOrder } from '../../../../facades/eagle/user';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import isUndefined from 'lodash/isUndefined';
import forEach from 'lodash/forEach';
import { updateOrderDetails } from '../../../data-providers/orders';
import { withModel } from '../../../data-providers/model';
import get from 'lodash/get';
import { addFlashMessageNotice } from '../../FlashMessages/duck';
import { connect } from 'react-redux';
import withOptimizely from '../../../hocs/withOptimizely';
import logger from 'src/logger';
import cookieFactory from '../../../../cookieFactory';
import { findKeyBy } from 'src/common/config/product';

const enhance = compose(
  connect(null, dispatch => ({
    addFlashMessageNotice: message => dispatch(addFlashMessageNotice(message)),
  })),
  withModel,
  withState('order', 'setOrder', props => props.currentOrder || {}),
  withProps(props => {
    const orderNumber = props.order.id || props.orderNumber;
    const orderStatus = props.order.isCancelled
      ? props.cancelledOrder
      : replaceTextWithValues(props.orderStatus, { state: props.orderStates.split(',')[props.order.status] });
    const isSignedIn = cookieFactory('isAuthenticated').get() === 'true';
    const orderUrl = localiseUrl(props.country, `/orders/${orderNumber}`);
    return {
      viewOrderUrl: orderUrl,
      viewOrderText: replaceTextWithValues(props.viewOrder, { number: orderNumber }),
      orderStatus: isUndefined(props.order.status)
        ? null
        : orderStatus,
      isEditable: !!(props.order.isOpen && isSignedIn),
      isSignedIn,
      loginUrl: localiseUrl(props.country, `/login?return_to=${orderUrl}`),
    };
  }),
  withOptimizely,
  lifecycle({
    componentDidMount() {
      const props = this.props;
      const orderNumber = props.order.id || props.orderNumber;
      const isOrderComplete = props.model.referrer && props.model.referrer.includes('checkout');
      if (!props.isInactiveOrders) {
        fetchOrder(orderNumber)
          .then(response => {
            const newOrders = updateOrderDetails(response, props.userOrders);
            const order = response.body.data;
            const orderTotal = parseFloat(order.total.amount);

            props.setUserOrders(newOrders);
            props.setOrder(order);

            if (isOrderComplete) {
              props.optimizely().push({
                type: 'event',
                eventName: 'orderComplete',
                tags: {
                  value: order.items.length,
                  revenue: orderTotal * 100, // (total order value including shipping - in cents)
                }
              });

              if (order.promoCode || parseInt(order.promoTotal.amount, 10)) {
                props.optimizely().push({
                  type: 'user',
                  attributes: {
                    discountUsed: true
                  }
                });
              }

              const productsOrdered = order.items.reduce((result, item) => {
                const productSku = item.format.product.id;
                const productKey = findKeyBy.sku(productSku);
                result[productKey] = result[productKey] ? result[productKey] + 1 : 1;
                return result;
              }, {});

              forEach(productsOrdered, (value, key) => {
                const eventName = `total${key}ProductsOrdered`;
                props.optimizely().push({
                  type: 'event',
                  eventName,
                  tags: { value }
                });
              });
            }
          })
          .catch(err => {
            if (err.status === 401) {
              const localisedLogin = localiseUrl(props.country, '/login');
              const currentPath = window.location.pathname;
              const currentSearch = window.location.search;
              const currentUrl = `${currentPath}${currentSearch}`;
              logger.info('Auth redirect: order', currentPath);
              window.location = `${localisedLogin}?return_to=${currentUrl}`;
            }
          });
      }
    },

    componentDidUpdate() {
      const props = this.props;
      if (props.order.isOpen && !props.order.isCancelled && props.order.shipping) {
        const estimatedDelivery = get(props.order, 'shipping.deliveryDate');
        const shippingTypes = Object.keys(estimatedDelivery);
        const deliveryDate = estimatedDelivery[shippingTypes[0]];
        const flashMessage = replaceTextWithValues(props.orderComplete, {
          date: deliveryDate.formatted,
        });
        if (flashMessage) {
          props.addFlashMessageNotice(flashMessage);
        }
      }
    }
  }),
);

export default enhance(UserOrder);



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserOrders/UserOrder/index.js